<template>
  <header class="sticky-top shadow">
    <nav class="navbar navbar-dark bg-primary">
      <button class="navbar-toggler" @click="toogleMenu">
        <small class="navbar-toggler-icon"></small>
      </button>

      <span class="navbar-brand mb-0 h1">
        <img src="../../assets/img/lifeplus-logo.png" height="18" class="d-inline-block align-middle ml-4" alt="">
        <small><small class="text-secondary ml-2">beta</small></small>
      </span>
    </nav>
  </header>
</template>

<script>
  export default {
    name: "Header",

    methods: {
      toogleMenu() {
        this.$emit('toogle-menu');
      },
    },
  };
</script>
